import { Component, Input, OnInit } from '@angular/core';
import { RoutePath } from 'app/routing/routes';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
    RoutePath = RoutePath;

    @Input() pageTitle: string;

    constructor() {}

    ngOnInit(): void {}
}
